// types.ts — tipos y constantes del Prompt Playground (ModPage).
// Qué exporta: interfaces de las secciones del mega-prompt, posts generados y
// respuestas de los endpoints /api/mod/playground/*; más las constantes de
// redes (NETWORKS) y labels de secciones (SECTION_LABELS).
// Quién lo usa: ModPage.tsx.
import type { SocialNetwork } from '@agency-smm/shared';

export interface MegaPromptSections {
  systemPrompt: string;
  generationRules: string;
  dynamicTextRules: string;
  imageRulesStock: string;
  imageRulesAi: string;
}

export interface GeneratedPost {
  index: number;
  content: string;
  stockImagePrompt: string | null;
  aiImagePrompt: string | null;
  headline: string;
  tagline: string;
  cta: string;
  quote: string;
}

export interface GenerateResponse {
  posts: GeneratedPost[];
  failedIndices: number[];
  /** Respuesta(s) cruda(s) del LLM antes de parsear/limpiar (una por mega-batch). */
  rawResponses: string[];
  assembledPrompt: string;
  systemPrompt: string;
  provider: string;
}

export interface PreviewResponse {
  systemPrompt: string;
  prompt: string;
  assignments: Array<{
    index: number;
    network: string;
    category: string;
    formatName: string;
    imageType: string;
  }>;
  sections: MegaPromptSections;
}

export const NETWORKS: { value: SocialNetwork; label: string }[] = [
  { value: 'instagram', label: 'Instagram' },
  { value: 'facebook', label: 'Facebook' },
  { value: 'twitter', label: 'Twitter/X' },
  { value: 'linkedin', label: 'LinkedIn' },
  { value: 'tiktok', label: 'TikTok' },
  { value: 'threads', label: 'Threads' },
  { value: 'gbp', label: 'GBP' },
  { value: 'bluesky', label: 'Bluesky' },
];

export const SECTION_LABELS: Record<keyof MegaPromptSections, string> = {
  systemPrompt: 'System Prompt',
  generationRules: 'Generation Rules',
  dynamicTextRules: 'Dynamic Text Rules',
  imageRulesStock: 'Stock Image Rules',
  imageRulesAi: 'AI Image Rules',
};
